import classes from "./Cart.module.css";
import Modal from "../UI/Modal";
import { useContext, useState } from "react";
import CartContext from "../../store/cart-context";
import CartItem from "./CartItem";
import CheckoutModal from "../UI/CheckoutModal";
import ThankModal from "../UI/ThankModal";

const Cart = (props) => {
  const [checkout, addCheckout] = useState(false); //for checkout component.
  const cartCtx = useContext(CartContext);
  const [showCartAfterCancelCheckout, setshowCartAfterCancelCheckout] =
    useState(true);
  const [thankYou, setThankYou] = useState(false);

  const cartItemRemoveHandeler = (id) => {
    cartCtx.deleteItem(id);
  };

  const cartItenAddHandeler = (item) => {
    cartCtx.addItem({ ...item, ammount: 1 }); //spread operator = make a copy/snapshot of the previous state.
  };

  const checkoutHandeler = () => {
    addCheckout(true);
    setshowCartAfterCancelCheckout(false);
  };

  const thankYouHandeler = () => {
    addCheckout(false);
    setshowCartAfterCancelCheckout(false);
    setThankYou(true);
  };

  const totalAmmount = `₹ ${cartCtx.totalAmount}`;
  const hasItems = cartCtx.items.length > 0;
  const cartItem = (
    <ul className={classes["cart-items"]}>
      {cartCtx.items.map((item) => ( // map convert array element in jsx
        <CartItem
          key={item.id}
          name={item.name}
          amount={item.ammount}
          price={item.price}
          onRemove={cartItemRemoveHandeler.bind(null, item.id)}
          onAdd={cartItenAddHandeler.bind(null, item)}
          // bind() allows you to set the context or this value for a function and create a new
          // function with that context. It returns a new function that, when called, will have
          // the same functionality as the original function, but with a specific this value.
          //matlab yeh hai ek new value k sath previos value ko bind kr deta hai.
          //yha pe us new item ko id dene k liye we use bind().
        />
      ))}
    </ul>
  );
  return (
    <div>
      {showCartAfterCancelCheckout && (
        <Modal onHideCart={props.onHideCart}>
          {cartItem}
          <div className={classes.total}>
            <span>Total Ammount</span>
            <span>{totalAmmount}</span>
          </div>

          <div className={classes.actions}>
            <button
              className={classes["button--alt"]}
              onClick={props.onHideCart} //jo app.js mae hai
            >
              Close
            </button>
            {hasItems && (
              <button onClick={checkoutHandeler} className={classes.button}>
                Order
              </button>
            )}
          </div>
        </Modal>
      )}

      {checkout && (
        <CheckoutModal onHideCart={props.onHideCart}>
         
        </CheckoutModal>
      )}

   
    </div>
  );
};

export default Cart;

//what is bind()
// const person = {
//   firstName: 'John',
//   lastName: 'Doe',
//   getFullName() {
//     return `${this.firstName} ${this.lastName}`;
//   }
// };

// const logName = function(message) {
//   console.log(`${message}: ${this.getFullName()}`);
// };

// const logJohnsName = logName.bind(person, 'Hello');
// logJohnsName(); // Output: Hello: John Doe
